import { render, staticRenderFns } from "./TypeGen.vue?vue&type=template&id=05990716&"
import script from "./TypeGen.vue?vue&type=script&lang=js&"
export * from "./TypeGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports